var map = {
	"./book-1.png": 3401,
	"./book-2.png": 3402,
	"./book-3.png": 3403,
	"./book-4.png": 3404,
	"./book-5.png": 3405,
	"./book-6.png": 3406
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 355;



//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers ^\.\/book\-.*\.png$
// module id = 355
// module chunks = 0